import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppApis } from '@app/core/APIs/app-apis';
import type {
  WorkflowChildConsumeRequest,
  WorkflowChildConsumeResult,
  WorkflowChildLinksRead,
} from './workflow-child-work.models';
@Injectable({ providedIn: 'root' })
export class WorkflowChildWorkService {
  private readonly http = inject(HttpClient);
  private readonly apis = inject(AppApis);
  private readonly headers = new HttpHeaders({
    'skip-error-interceptor': 'yes',
    'skip-loading-interceptor': 'yes',
  });
  read(workflowId: number, occurrenceId: number) {
    return this.http.get<WorkflowChildLinksRead>(
      `${this.apis.core.baseUrl}/api/platform/workflows/${workflowId}/children`,
      {
        headers: this.headers,
        withCredentials: true,
        params: { occurrenceId },
      },
    );
  }
  consume(
    workflowId: number,
    request: WorkflowChildConsumeRequest,
    idempotencyKey: string,
  ) {
    return this.http.post<WorkflowChildConsumeResult>(
      `${this.apis.core.baseUrl}/api/platform/workflows/${workflowId}/children/consume`,
      request,
      {
        headers: this.headers
          .set('If-Match', request.expectedETag)
          .set('Idempotency-Key', idempotencyKey),
        withCredentials: true,
      },
    );
  }
}
